export default {
  // 当前站点域名
  domain: process.env.DOMAIN,
  // 业务接口域名
  baseApiDomain: process.env.BASE_API_DOMAIN,
  // 微信接口域名
  wxApiDomain: process.env.WX_API_DOMAIN,
  // 文件上传域名
  fileUploadDomain: process.env.FILE_UPLOAD_DOMAIN,
  // 文件显示域名
  fileShowDomain: process.env.FILE_SHOW_DOMAIN,
  // 当前项目要使用的公众号ID
  mpId: 2,
  // 默认微信分享配置
  wxShare: {
    // 分享标题
    title: '麦田格网校',
    // 分享链接
    link: "",
    // 分享描述
    desc: '麦田格作文线上课网课平台，让写作更快乐，更简单！为中小学生提供写作素材、美文赏析、中高考作文线上课、升学资讯。 帮助每一个孩子写好作文！',
    // 分享图标
    imgUrl: 'http://res.maitiange.com/image/20190514/4d48d8bc-6dc4-4bf0-8fa2-c35c45e6ba3b.jpg?imageMogr2/thumbnail/100x100!',
    type: 'link'
  },
  periodList:[
    {
      id:"02",
      name:"小学",
      gradeList:[
        {id:"04",name:"一年级"},
        {id:"05",name:"二年级"},
        {id:"06",name:"三年级"},
        {id:"07",name:"四年级"},
        {id:"08",name:"五年级"},
        {id:"09",name:"六年级"}
      ]
    },
    {
      id:"03",
      name:"初中",
      gradeList:[
        {id:"10",name:"初一"},
        {id:"11",name:"初二"},
        {id:"12",name:"初三"}
      ]
    },
    {
      id:"04",
      name:"高中",
      gradeList:[
        {id:"13",name:"高一"},
        {id:"14",name:"高二"},
        {id:"15",name:"高三"}
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/Global.js